var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Table } from 'src/ui/components/Table/Table';
import { UserItem } from 'src/ui/views/users/sections/UsersTable/UserItem';
import styles from 'src/ui/views/cases/sections/CasesTable/casesTable.module.scss';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { LoadingTableItem } from 'src/ui/components/Table/LoadingTableItem';
export var UsersTable = function (props) {
    var i18n = props.i18n, users = props.users, isLoading = props.isLoading, columns = props.columns, onEditUser = props.onEditUser, onDeleteUser = props.onDeleteUser;
    var handleOnDeleteUser = function (e, user) {
        e.stopPropagation();
        onDeleteUser(user);
    };
    var handleOnEditUser = function (e, user) {
        e.stopPropagation();
        onEditUser(user);
    };
    if (isLoading) {
        var skeletonArray = Array.from(Array(25), function (_, index) { return ({
            id: index.toString(),
            isLocked: false,
            values: Array.from(Array(columns.length), function () { return ({ text: '', style: {} }); }),
        }); });
        return (_jsx(Table, { collection: skeletonArray, columns: columns, itemRender: function () { return _jsx(LoadingTableItem, { nbOfValues: columns.length }); } }));
    }
    if (!users || users.length === 0) {
        return (_jsx("div", __assign({ className: styles.placeholderWrapper }, { children: _jsx("p", { children: getPropsByKeyPath(i18n, 'components.userList.emptyList') }) })));
    }
    return (_jsx(Table, { collection: users, columns: columns, itemRender: function (user) { return (_jsx(UserItem, { i18n: i18n, content: user.values, isLocked: user.isLocked, onDelete: function (e) { return handleOnDeleteUser(e, user); }, onEdit: function (e) { return handleOnEditUser(e, user); } })); } }));
};
